module.exports = __webpack_public_path__ + "static/media/paper-plane.1fb39e96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/paper-plane.svg
// module id = 103
// module chunks = 0